import "./PerformanceLab.module.css";
import Header from "@/reusable_sections/Header";
import SpeedAgilityCatalog from "./sections/SpeedAgilityCatalog";
import BrandPartners from "./sections/BrandPartners";
import TheStrideFooter from "@/reusable_sections/Footer";
export default function PerformanceLabPage() {
  return <div>
      <Header />
      <SpeedAgilityCatalog />
      <BrandPartners />
      <TheStrideFooter />
    </div>;
}